import {Model} from "./";
import {Api} from "../api";

class ReturnModel extends Model {

    constructor() {
        super(new Api("/return"));
    }

    getTypes(thenFunction, errorFunction) {
        this.q.setDopUrl('/type');
        this.q.read({}, thenFunction, errorFunction);
    }

    getReason(thenFunction, errorFunction) {
        this.q.setDopUrl('/reason');
        this.q.read({}, thenFunction, errorFunction);
    }

    getList(clientId, thenFunction, errorFunction) {
        this.q.setDopUrl('/list');
        this.q.read({
            clientId: clientId,
            page: 1
        }, thenFunction, errorFunction);
    }

    addReturn(ob, thenFunction, errorFunction) {
        this.q.setDopUrl('');
        this.q.create(ob, thenFunction, errorFunction);
    }

}

export default new ReturnModel();